module.exports = __webpack_public_path__ + "img/account.8a156920.svg";